import { mapGetters } from 'vuex'

import {
  // factoryCoo,
  factory,
  qasLastUser,
  qasHasMapping,
  // qasBrand,
  qasVendor,
  qasQARegion,
  qasCountryPQA,
  qasAuditStage,
  qasAuditStatus,
  qasAuditorName,
  qasDefects,
  qasAuditPoint,
  qasUserAuditPoint,
  qasFolder
} from './definition'

export default {
  // [factoryCoo] (state, getters) {
  //   return state.factoryCoo
  // },
  [factory] (state, getters) {
    return state.factory
  },
  // [qasBrand] (state, getters) {
  //   return state.qasBrand
  // },
  [qasVendor] (state, getters) {
    return state.qasVendor
  },
  [qasQARegion] (state, getters) {
    return state.qasQARegion
  },
  [qasCountryPQA] (state, getters) {
    return state.qasCountryPQA
  },
  [qasAuditStage] (state, getters) {
    return state.qasAuditStage
  },
  [qasAuditStatus] (state, getters) {
    return state.qasAuditStatus
  },
  [qasAuditorName] (state, getters) {
    return state.qasAuditorName
  },
  [qasLastUser] (state, getters) {
    return state.qasLastUser
  },
  [qasHasMapping] (state, getters) {
    return state.qasHasMapping
  },
  [qasDefects] (state, getters) {
    return state.qasDefects
  },
  [qasAuditPoint] (state, getters) {
    return state.qasAuditPoint
  },
  [qasUserAuditPoint] (state, getters) {
    return state.qasUserAuditPoint
  },
  [qasFolder] (state, getters) {
    return state.qasFolder
  }
}

export const getters = mapGetters({
  // factoryCoo,
  factory,
  // qasBrand,
  // qasVendor,
  qasQARegion,
  qasAuditStage,
  qasAuditStatus,
  qasAuditorName,
  qasLastUser,
  qasHasMapping,
  qasDefects,
  qasAuditPoint,
  qasUserAuditPoint,
  qasFolder
})



// WEBPACK FOOTER //
// ./src/components/qas/common/store/getters.js